export default __webpack_public_path__ + "images/25_1_image.jpg";